export default "/assets/images/quiet-mode.8bbfdf1872e62ec6.webm";